import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'normalizeNbsp',
  standalone: true,
})
export class NormalizeNbspPipe implements PipeTransform {
  transform(html: string | null): string {
    return (html ?? '').replace(/&nbsp;/g, ' ').replace(/\u00A0/g, ' ');
  }
}
